const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    width: 16,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "c add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinecap: "round",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    className: "nc-icon-wrapper",
    strokeLinejoin: "round",
    transform: "matrix(1, 0, 0, 1, -1, -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7,
    style: {
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 4.5,
    x2: 8.5,
    y2: 12.5,
    style: {
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 8.5,
    x2: 12.5,
    y2: 8.5,
    style: {
      stroke: "rgb(255, 255, 255)",
      strokeOpacity: 0.75
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCAdd);
export default __webpack_public_path__ + "static/media/c-add.478d4643959db214b3a88d183c1d4f5e.svg";
export { ForwardRef as ReactComponent };